<template>
  <layout-mypage current="mypage/blogs">
    <h1
      v-if="!isFromCoconalaApp"
      class="c-blogs_headerTitle"
    >
      ブログ管理
    </h1>
    <blog-delete-modal
      :is-visible="isVisibleDeleteModal"
      closeText="キャンセル"
      @close="isVisibleDeleteModal = false"
      @deleteBlog="deleteBlog(targetBlog)"
    >
      <div slot="body">
        ブログを削除します。<br>
        よろしいですか？
      </div>
    </blog-delete-modal>
    <blog-kind-select-modal
      :blog-kind.sync="kind"
      :is-visible="kindModal"
      :is-paid="paid"
      @close="kindModal = false"
      @startEdit="startEdit()"
    />
    <blog-paid-required-modal
      :is-visible="isVisiblePaidRequiredModal"
      :is-provider="isProvider"
      :sms-authentication-fg="bloggerRegistrationStatus.smsAuthenticationFg"
      @close="isVisiblePaidRequiredModal = false"
    />
    <blog-post-ie-alert
      :is-visible="isVisibleIeAlert"
      @close="isVisibleIeAlert = false"
    />
    <div class="c-blogs_container">
      <b-loading
        v-if="$fetchState.pending"
        :active="$fetchState.pending"
        :is-full-page="false"
      />
      <template v-else>
        <div
          class="c-blogsNotice"
          v-if="!isProvider || !bloggerRegistrationStatus.smsAuthenticationFg"
        >
          <div class="c-blogsNotice_requiredInfomation">
            <div>有料公開する場合、<a :href="userInformationRegisterUrl">出品者情報</a>と<NuxtLink :to="smsRegisterUrl">電話番号</NuxtLink>が必要です。</div>
            <a @click="isVisiblePaidRequiredModal = true">登録の状況はこちら</a>
          </div>
        </div>
        <div
          class="c-emptyBlogs"
          v-if="total === 0"
        >
          <div class="c-emptyBlogs_title">ブログを投稿しましょう</div>
          <div class="c-emptyBlogs_message">
            あなたもブログを書いてみませんか？<br>多くの人へ情報発信が簡単にできます。
            <span
              class="c-emptyBlogs_notice"
              v-if="!isMypagePC"
            ><br>ブログ投稿はPCのみご利用可能です
            </span>
          </div>
          <c-button-v2
            size="m"
            width="256px"
            color="primary-blue"
            :disabled="!isMypagePC"
            @click="showKindModal"
          >ブログを投稿する</c-button-v2>
        </div>
        <template v-if="total > 0">
          <!-- 新規記事投稿 -->
          <new-item-add
            class="c-blogs_newPanel"
            type="card"
            @click="showKindModal"
          />
          <!-- 記事数表示 -->
          <div class="c-blogs_total">{{ total }}記事</div>
          <!-- 記事一覧 -->
          <!-- eslint-disable-next-line vue/require-component-is -->
          <component
            v-for="(blog, index) in blogsList"
            :key="index"
            class="c-blogContent"
            :is="!isMypagePC && blog.status === STATUS.OPEN ? 'a' : 'div'"
            :href="!isMypagePC && blog.status === STATUS.OPEN ? `/blogs/${blog.userId}/${blog.id}` : ''"
          >
            <div class="c-blogContent_thumbnail">
              <div>
                <div class="c-blogContent_title">
                  <component
                    :is="isMypagePC && blog.status === STATUS.OPEN ? 'nuxt-link' : 'span'"
                    :to="isMypagePC && blog.status === STATUS.OPEN ? `/blogs/${blog.userId}/${blog.id}` : ''"
                  >
                    {{ $util.truncate(blog.title, maxTitle) }}
                  </component>
                  <span class="c-blogContent_kind">
                    <coconala-icon
                      size="10px"
                      :name="kindIconName(blog.kind)"
                    />
                    {{ kindText(blog.kind) }}
                  </span>
                </div>
                <div class="c-blogContent_category">{{ blog.blogCategory.name }}</div>
              </div>
              <img
                v-if="blog.coverImageUrl"
                class="c-blogContent_img"
                :src="blog.coverImageUrl"
                loading="lazy"
              />
            </div>
            <div class="c-blogContent_heading">
              <div>
                <span :class="blog.status === STATUS.DRAFT ? 'c-blogContent_statusDraft' : 'c-blogContent_statusPublic'">
                  {{ blog.status === STATUS.DRAFT ? '下書き' : '公開中'}}
                </span>
                <span class="c-blogContent_postDate">
                  {{ $util.dayjs.unix(blog.openedAt || blog.createdAt).format('YYYY/MM/DD HH:mm') }}
                </span>
              </div>
              <div class="c-blogContent_paidInfo">
                <span
                  class="c-blogContent_price"
                  v-if="blog.paidFg && blog.price"
                >{{ blog.price | withDelimiter }}円</span>
                <span
                  class="c-blogContent_paidOrderCount"
                  :class="{ 'c-blogContent_paidOrderCount-sidePrice' : blog.paidFg && blog.price }"
                  v-if="blog.paidFg || blog.paidOrdersCount > 0"
                >販売数：{{ blog.paidOrdersCount }}</span>
              </div>
              <div class="c-blogContent_action">
                <a
                  class="c-blogContent_edit"
                  @click="goToEdit(blog.id)"
                >
                  <coconala-icon name="pencil-square-o" />
                  編集する
                </a>
                <b-dropdown
                  aria-role="list"
                  position="is-bottom-left"
                >
                  <a slot="trigger">
                    <coconala-icon
                      name="ellipsis-h"
                      color="secondary"
                      size="16px"
                    />
                  </a>
                  <b-dropdown-item
                    v-if="canDraft(blog)"
                    aria-role="listitem"
                    has-link
                  >
                    <a @click="changeBlogStatus(blog, STATUS.DRAFT)">下書きに戻す</a>
                  </b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    has-link
                  >
                    <a @click="showDeleteModal(blog)">削除</a>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </component>
          <c-pagination
            class="c-blogs_pagination"
            order="is-centered"
            :total="total"
            :per-page="DEFAULT_PAGE_LIMIT"
            :current="page"
            theme="pagination-gray"
            has-link
          />
        </template>
      </template>
    </div>
    <the-vueport breakpointType="vueportMypage" />
  </layout-mypage>
</template>

<script>
import LayoutMypage from '~/components/templates/LayoutMypage'
import EmptyPanel from '~/components/molecules/EmptyPanel'
import NewItemAdd from '~/components/molecules/NewItemAdd'
import BlogDeleteModal from '~/components/organisms/BlogDeleteModal'
import BlogKindSelectModal from '~/components/organisms/BlogKindSelectModal'
import BlogPaidRequiredModal from '~/components/organisms/BlogPaidRequiredModal'
import BlogPostIeAlert from '~/components/organisms/BlogPostIeAlert'
import CPagination from '~/components/molecules/CPagination'
import TheVueport from '~/components/organisms/TheVueport'

// vuex
import { mapGetters, mapState } from 'vuex'

const FOOTER_CLASS = 'js-the-footer'
const FOOTER_ADD_CLASS = 'c-theFooter-withoutMarginTopOnMypageBlog'

// middleware
import authenticated from '~/middleware/authenticated'

const DEFAULT_PAGE_LIMIT = 20
const MAX_TITLE_PC = 60
const MAX_TITLE_SP = 32

export default {
  components: {
    LayoutMypage,
    EmptyPanel,
    NewItemAdd,
    BlogDeleteModal,
    BlogKindSelectModal,
    BlogPaidRequiredModal,
    BlogPostIeAlert,
    CPagination,
    TheVueport
  },
  head() {
    return {
      title: `${this.$store.state.auth.user.name}ブログ一覧(編集)｜coconalaブログ`
    }
  },
  middleware: ['authenticated', 'redirectToTopIfBusinessAccount'],
  fetchOnServer: false,
  async fetch() {
    this.page = /^\d+$/.test(this.$util.castToNumberQueryString(this.$route.query.page))
      ? this.$util.castToNumberQueryString(this.$route.query.page)
      : 1
    await this.$store.dispatch('pages/mypage/blogs/fetchBlogs', this.page).catch(({ grpcCode }) => {
      const statusCode = this.$util.grpcCodeToHttpStatusCode(grpcCode)
      return this.$nuxt.context.error({
        statusCode,
        message: '',
        grpcCode
      })
    })
  },
  created() {
    if (this.$route.query.new) {
      this.showKindModal()
      this.$router.replace({ name: 'mypage-blogs' }, () => {})
    }
  },
  asyncData({ app, store, error }) {
    return store
      .dispatch('auth/user/getBloggerRegistrationStatus')
      .then(res => {
        return { bloggerRegistrationStatus: res }
      })
      .catch(err => {
        const statusCode = app.$util.grpcCodeToHttpStatusCode(err.grpcCode)
        return error({
          statusCode,
          message: '',
          grpcCode: err.grpcCode
        })
      })
  },
  mounted() {
    this.checkEditError()
    this.footerGetTimer = setInterval(this.setFooterMargin, 500)
  },
  destroyed() {
    const footer = document.querySelector('.' + FOOTER_CLASS)
    if (footer) footer.classList.remove(FOOTER_ADD_CLASS)
    clearInterval(this.footerGetTimer)
  },
  data() {
    return {
      DEFAULT_PAGE_LIMIT,
      page: 1,
      targetBlog: null,
      isVisibleDeleteModal: false,
      isVisiblePaidRequiredModal: false,
      isVisibleIeAlert: false,
      kindModal: false,
      kind: this.$store.state.pages.blogs.constants.KIND.NORMAL,
      footerGetTimer: null,
      bloggerRegistrationStatus: {
        antisocialCheckFg: true,
        notSellFg: false,
        providerType: this.$store.state.constants.PROVIDER_TYPE.SOLO,
        smsAuthenticationFg: true
      },
      paid: !!this.$route.query.paid
    }
  },
  computed: {
    ...mapGetters('auth', ['isFromCoconalaApp', 'isFromIE']),
    ...mapGetters('ui', ['isPC', 'isMypagePC']),
    ...mapState('ui', ['viewport']),
    ...mapState('auth', ['user']),
    ...mapState('pages/mypage/blogs', ['blogsList', 'total']),
    ...mapState('pages/blogs/constants', ['STATUS', 'KIND', 'NO_CATEGORY_ID']),
    ...mapState('constants', ['PROVIDER_TYPE']),
    maxTitle() {
      return this.isPC ? MAX_TITLE_PC : MAX_TITLE_SP
    },
    userInformationRegisterUrl() {
      return this.$coconala.url('/mypage/user_information', { redirect_to: '/mypage/blogs' })
    },
    smsRegisterUrl() {
      return '/mypage/sms?redirect_to=/mypage/blogs'
    },
    isProvider() {
      return this.bloggerRegistrationStatus.providerType !== this.PROVIDER_TYPE.NONE
    }
  },
  watch: {
    $route: {
      handler() {
        this.checkEditError()
        if (this.$route.query.new) {
          this.showKindModal()
          // queryを取り除く
          this.$router.replace({ name: 'mypage-blogs' }, () => {})
        }
      }
    },
    '$route.query.page': '$fetch'
  },
  methods: {
    showKindModal() {
      // IEの場合はEditorは非対応のため記事選択ではなくアラートを表示
      if (this.isFromIE) {
        this.isVisibleIeAlert = true
      } else {
        this.kindModal = true
      }
    },
    async goToEdit(blogId) {
      // IEの場合はEditorは非対応のためアラートを表示
      if (this.isFromIE) {
        this.isVisibleIeAlert = true
        return
      }
      try {
        // 記事公開制限を確認する
        await this.setBloggerRegistrationStatus()
        if (this.bloggerRegistrationStatus.notSellFg) {
          this.$notify({
            group: 'flash',
            title: '現在ブログを編集できません',
            type: 'error-text-center'
          })
          return
        }
        this.$router.push({ path: `/mypage/blogs/edit/${blogId}` }, () => {})
      } catch ({ grpcCode, message }) {
        const title = this.$util.getNotifyErrorTitle(grpcCode, message)
        const text = this.$util.getNotifyErrorText(grpcCode, message)
        this.$notify({
          group: 'flash',
          title,
          text,
          type: 'error',
          max: 1
        })
      }
    },
    async changeBlogStatus(blog, status) {
      try {
        // 記事公開制限を確認する
        await this.setBloggerRegistrationStatus()
        if (this.bloggerRegistrationStatus.notSellFg) {
          this.$notify({
            group: 'flash',
            title: '現在ブログを編集できません',
            type: 'error-text-center'
          })
          return
        }
        await this.$store.dispatch('pages/mypage/blogs/updateStatus', {
          blog,
          status,
          page: this.$route.query.page
        })
        this.$notify({
          group: 'flash',
          type: 'success',
          title: `ブログを${status === this.STATUS.DRAFT ? '下書きに戻しました' : '公開しました'}`
        })
      } catch ({ grpcCode, message }) {
        const title = this.$util.getNotifyErrorTitle(grpcCode, message)
        const text = this.$util.getNotifyErrorText(grpcCode, message)
        this.$notify({
          group: 'flash',
          title,
          text,
          type: 'error',
          max: 1
        })
      }
    },
    async deleteBlog(blog) {
      try {
        // 記事公開制限を確認する
        await this.setBloggerRegistrationStatus()
        if (this.bloggerRegistrationStatus.notSellFg) {
          this.$notify({
            group: 'flash',
            title: '現在ブログを編集できません',
            type: 'error-text-center'
          })
          this.isVisibleDeleteModal = false
          return
        }
        // 販売実績のあるブログは削除できない
        if (blog.paidOrdersCount && blog.status === this.STATUS.OPEN) {
          this.$notify({
            group: 'flash',
            title: '販売実績のあるブログのため削除できません',
            type: 'error-text-center'
          })
          this.isVisibleDeleteModal = false
          return
        }
        await this.$store.dispatch('pages/mypage/blogs/deleteBlog', {
          blogId: blog.id,
          page: this.$route.query.page
        })
        this.$notify({
          group: 'flash',
          type: 'success',
          title: 'ブログを削除しました'
        })
      } catch ({ grpcCode, message }) {
        const title = this.$util.getNotifyErrorTitle(grpcCode, message)
        const text = this.$util.getNotifyErrorText(grpcCode, message)
        this.$notify({
          group: 'flash',
          title,
          text,
          type: 'error',
          max: 1
        })
      }
      this.isVisibleDeleteModal = false
    },
    showDeleteModal(blog) {
      this.targetBlog = blog
      this.isVisibleDeleteModal = true
    },
    // 3点ボタンで下書きボタンを表示するかの判定
    canDraft(blog) {
      // 下書きのブログは非表示
      if (blog.status === this.STATUS.DRAFT) {
        return false
      }

      // 販売実績があるブログは非表示
      if (blog.paidOrdersCount) {
        return false
      }
      return true
    },
    async startEdit() {
      try {
        // 記事公開制限を確認する
        await this.setBloggerRegistrationStatus()
        if (this.bloggerRegistrationStatus.notSellFg) {
          this.$notify({
            group: 'flash',
            title: '現在ブログを投稿できません',
            type: 'error-text-center'
          })
          return
        }
        this.$router.push(
          { path: '/mypage/blogs/add', query: { kind: this.kind, paid: this.paid } },
          () => {}
        )
      } catch ({ grpcCode, message }) {
        const title = this.$util.getNotifyErrorTitle(grpcCode, message)
        const text = this.$util.getNotifyErrorText(grpcCode, message)
        this.$notify({
          group: 'flash',
          title,
          text,
          type: 'error',
          max: 1
        })
      }
    },
    checkEditError() {
      if (this.$route.query.editError) {
        this.$nextTick(() => {
          this.$notify({
            group: 'flash',
            title: '現在ブログを投稿・編集できません',
            type: 'error-text-center'
          })
        })
        // queryを取り除く
        this.$router.replace({ name: 'mypage-blogs' }, () => {})
      }
    },
    /**
     * 投稿制限に必要な情報を取得する
     */
    async setBloggerRegistrationStatus() {
      this.bloggerRegistrationStatus = await this.$store.dispatch(
        'auth/user/getBloggerRegistrationStatus'
      )
    },
    isKindNormal(kind) {
      return kind === this.KIND.NORMAL
    },
    isKindContents(kind) {
      return kind === this.KIND.CONTENTS
    },
    isKindAnnounce(kind) {
      return kind === this.KIND.ANNOUNCE
    },
    kindIconName(kind) {
      if (this.isKindNormal(kind)) return 'blog-article'
      if (this.isKindContents(kind)) return 'blog-content'
      if (this.isKindAnnounce(kind)) return 'blog-announce'
      return 'blog-article'
    },
    kindText(kind) {
      return this.$store.getters['pages/blogs/constants/kindText'](kind)
    },
    setFooterMargin() {
      const footer = document.querySelector('.' + FOOTER_CLASS)
      if (footer) {
        footer.classList.add(FOOTER_ADD_CLASS)
        clearInterval(this.footerGetTimer)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-blogs {
  &_headerTitle {
    margin-bottom: 24px;
    font-size: 28px;
    line-height: 1;
  }

  &_newPanel {
    margin: 24px 20px;
    height: 174px;
  }

  &_container {
    position: relative; // loading用
    min-height: 678px;
    max-width: 744px;
    border: 1px solid $color-gray-200;
    border-radius: 4px;
  }

  &_total {
    margin-top: 24px;
    padding: 20px 20px 8px;
    border-bottom: 1px solid $color-gray-200;
    color: $color-gray-700;
    font-size: 12px;
  }

  &_pagination {
    margin: 44px 0 32px;
  }
}

.c-blogsNotice {
  margin: 24px 20px;
  padding: 16px 20px;
  background-color: $color-yellow-50;

  &_requiredInfomation {
    display: flex;

    justify-content: space-between;
  }
}

.c-emptyBlogs {
  padding: 116px 0 320px;
  text-align: center;

  &_title {
    margin-bottom: 12px;
    font-weight: bold;
    font-size: 16px;
  }

  &_message {
    margin-bottom: 32px;
  }
}

.c-blogContent {
  display: block;
  padding: 16px 20px;
  border-bottom: 1px solid $color-gray-200;

  &_heading {
    display: flex;
    margin-top: 8px;
  }

  &_statusPublic {
    margin-right: 16px;
    padding: 4px 12px;
    width: 60px;
    height: 20px;
    background-color: $color-green-500;
    color: $color-white;
    font-weight: bold;
    font-size: 12px;
  }

  &_statusDraft {
    margin-right: 16px;
    padding: 4px 12px;
    width: 60px;
    height: 20px;
    background-color: $color-gray-400;
    color: $color-white;
    font-weight: bold;
    font-size: 12px;
  }

  &_postDate {
    margin-right: 20px;
    color: $color-gray-600;
    font-size: 14px;
  }

  &_price {
    margin-right: 4px;
  }

  &_paidOrderCount {
    &-sidePrice {
      padding-left: 8px;
      border-left: 1px solid $color-gray-200;
    }
  }

  &_action {
    margin-left: auto;
    a {
      @include link-effect;
    }

    i {
      color: $color-gray-700;
    }
    /deep/ .dropdown-menu {
      top: 12px;
      right: -18px;
      left: unset;
      .has-link {
        a {
          color: $color-font-base;
          &:hover {
            background-color: $color-blue-500;
            color: $color-white;
            opacity: 1;
          }
        }
      }
    }
  }

  &_edit {
    margin-right: 16px;
    font-size: 12px;

    i {
      color: $color-blue-500;
    }
  }

  &_thumbnail {
    display: flex;

    justify-content: space-between;
  }

  &_img {
    min-width: 85px;
    width: 85px;
    height: 48px;
    border-radius: 6px;
  }

  &_title {
    margin-right: 36px;
    color: $color-gray-900;
    font-weight: bold;
    font-size: 16px;

    a {
      @include link-effect;

      color: $color-gray-900;
    }
  }

  &_kind {
    color: $color-gray-600;
    font-weight: normal;
    font-size: 10px;

    .coconala-icon {
      margin-left: 8px;
      vertical-align: -1px;
    }
  }

  &_category {
    color: $color-gray-600;
    font-size: 12px;
  }
}

@media (max-width: breakpoint(Mypage, L)) {
  .c-blogs {
    &_headerTitle {
      margin: 0;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      line-height: 40px;
    }

    &_newPanel {
      display: none !important;
    }

    &_total {
      display: none;
    }

    &_container {
      max-width: none;
      border: 0;
      background: $color-gray-50;
    }

    &_pagination {
      margin: 0;
      padding-top: 40px;
      padding-bottom: 80px;
    }
  }

  .c-blogsNotice {
    display: none;
  }

  .c-emptyBlogs {
    padding: 24px 0 80px;
    border-top: 1px solid $color-gray-200;

    &_notice {
      color: $color-red-500;
      font-weight: bold;
    }
  }

  .c-blogContent {
    margin-right: 0;
    margin-bottom: 8px;
    padding: 12px;
    border: 0;
    border-top: 1px solid $color-gray-200;
    border-bottom: 1px solid $color-gray-200;
    border-radius: 0;
    background: $color-white;

    &_img {
      min-width: 100px;
      width: 100px;
      height: 56px;
    }

    &_title {
      margin-right: 0;
      font-size: 14px;
    }

    &_statusPublic {
      margin-right: 8px;
      width: 48px;
      height: 18px;
      font-size: 10px;
    }

    &_statusDraft {
      margin-right: 8px;
      width: 48px;
      height: 18px;
      font-size: 10px;
    }

    &_postDate {
      margin-right: 0;
      font-size: 12px;
    }

    &_paidInfo {
      margin-left: auto;
    }

    &_price {
      margin-right: 4px;
      color: $color-gray-900;
      font-size: 12px;
    }

    &_paidOrderCount {
      color: $color-gray-900;
      font-size: 12px;
    }

    &_action {
      display: none;
    }
  }
}
</style>
